import GraphRanges from "@/mixins/GraphRanges";
import { Patient } from "@/store/modules/patient/types";
import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { MultiChartConfig } from "../shared/chart/MultiChartWithSharedRange";

const patientNamespace = { namespace: "patient" };
@Component({})
export default class Sofa extends mixins(GraphRanges) {
  @Getter("graph", patientNamespace)
  graph: any;

  @Getter("current", patientNamespace)
  current!: Patient;

  created() {
    this.selectedTime = 24;
  }

  sofaConfig = {
    pfRatio: [
      "&ge; 400",
      "&lt; 400",
      "&lt; 300",
      "&lt; 200 on vent",
      "&lt; 100 on vent"
    ],
    GCS: ["&ge; 15", "&lt; 15", "&lt; 13", "&lt; 10", "&lt; 6"],
    //
    Bilirubin: ["&lt; 1.2", "&ge; 1.2", "&ge; 2.0", "&ge; 6.0", "&ge; 12.0"],
    platelet: ["&ge; 150", "&lt; 150", "&lt; 100", "&lt; 50", "&lt; 20"],
    cr: [
      "&lt; 1.2",
      "&ge; 1.2",
      "&ge; 2",
      "&ge; 3.5 or<br />Urine &lt; 500 ml/day",
      "&ge; 5.0 or<br />Urine &lt; 200 ml/day or Dialysis"
    ],
    cardio: [
      "",
      "MAP &lt; 70",
      "Dop &le; 5 or <br />Dob any",
      "Dop &gt; 5 or <br />Epi &le; 0.1 or <br />Nor &le; 0.1",
      "Dop &gt; 15 or <br />Epi &gt; 0.1 or <br />Nor &gt; 0.1"
    ]
  };

  sofaTableColors = [
    "tableGreen",
    "tableYellow",
    "tableYellow",
    "tableYellow",
    "tableRed"
  ];

  get charts(): MultiChartConfig[] {
    return [
      {
        title: "SOFA",
        data: this.graph(["SOFA"]),
        max: 24,
        library: {
          scales: {
            yAxes: [
              {
                ticks: {
                  maxTicksLimit: 8,
                  stepSize: 4
                }
              }
            ]
          }
        }
      }
    ];
  }

  get scores() {
    const [
      pfRatio,
      GCS,
      Bilirubin,
      platelet,
      cr,
      cardio
    ] = this.current.body.atoms.sofa.legend
      .split(",")
      .map((index: string) => parseInt(index, 10));
    return { pfRatio, GCS, Bilirubin, platelet, cr, cardio };
  }

  get pfRatio() {
    const text = this.current.body.atoms.pafi.legend;
    const index = this.scores.pfRatio;
    const threshold = this.sofaConfig["pfRatio"][index];
    const tableColor = this.sofaTableColors[index];
    return { text, index, threshold, tableColor };
  }

  get GCS() {
    const text = this.current.body.current.GCS.value;
    const index = this.scores.GCS;
    const threshold = this.sofaConfig["GCS"][index];
    const tableColor = this.sofaTableColors[index];
    return { text, index, threshold, tableColor };
  }
  get Bilirubin() {
    const text = this.current.body.current.Bilirubin.value;
    const index = this.scores.Bilirubin;
    const threshold = this.sofaConfig["Bilirubin"][index];
    const tableColor = this.sofaTableColors[index];
    return { text, index, threshold, tableColor };
  }

  get platelet() {
    const text = this.current.body.atoms.platelet.legend.replace("|", " ");
    const index = this.scores.platelet;
    const threshold = this.sofaConfig["platelet"][index];
    const tableColor = this.sofaTableColors[index];
    return { text, index, threshold, tableColor };
  }

  get cr() {
    const text =
      this.current.body.atoms.cr.value +
      ", " +
      Math.round(this.current.body.atoms.urine24.value) +
      " ml";
    const index = this.scores.cr;
    const threshold = this.sofaConfig["cr"][index];
    const tableColor = this.sofaTableColors[index];
    return { text, index, threshold, tableColor };
  }

  get cardio() {
    const text = "";
    const index = this.scores.cardio;
    const threshold = this.sofaConfig["cardio"][index];
    const tableColor = this.sofaTableColors[index];
    return { text, index, threshold, tableColor };
  }
}
